document.addEventListener("turbo:load", () => {
  const scroll = document.getElementById("benevolat-scroll");
  const pagination = document.getElementById("benevolat-pagination");

  if (!scroll || !pagination) return;

  const cards = scroll.querySelectorAll(".benevolat-card");
  const gap = 25;
  const cardWidth = cards[0].offsetWidth + gap;
  const visibleCards = Math.floor(scroll.offsetWidth / cardWidth);
  const totalPages = Math.ceil(cards.length / visibleCards);

  pagination.innerHTML = "";

  for (let i = 0; i < totalPages; i++) {
    const dot = document.createElement("span");

    dot.addEventListener("click", () => {
      scroll.scrollTo({
        left: i * visibleCards * cardWidth,
        behavior: "smooth"
      });
    });

    pagination.appendChild(dot);
  }

  scroll.addEventListener("scroll", () => {
    const currentIndex = Math.round(scroll.scrollLeft / (visibleCards * cardWidth));

    pagination.querySelectorAll("span").forEach((dot, i) => {
      dot.classList.toggle("active", i === currentIndex);
    });
  });

  if (pagination.firstChild) {
    pagination.firstChild.classList.add("active");
  }
});